// extracted by mini-css-extract-plugin
export default {"tbl":"StatTable_tbl__6fi1-","th":"StatTable_th__kfAvv","td":"StatTable_td__7dpqc"};